import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchCurrentUser } from 'store';
import { getEnv } from 'utils';

const ChatbotOnlyRedirect = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector(
    (state) => state.accountReducer.currentUser?.access_token || ''
  );
  useEffect(() => {
    const fetchUser = async () => {
      const chatbotBaseUrl = getEnv('REACT_APP_CHATBOT_URL');

      try {
        await dispatch(fetchCurrentUser(token)).unwrap();
      } catch (error) {
        navigate('/login', { replace: true });
        return;
      }

      if (chatbotBaseUrl && token) {
        window.open(
          `${chatbotBaseUrl}/auth/callback?token=${token}&from=${window.location.origin}`,
          '_self'
        );
      }
    };
    fetchUser();
  }, []);

  return null;
};

export default ChatbotOnlyRedirect;
